import React from 'react';
import { bool, func } from 'prop-types';
import styled, { css } from 'styled-components';
import {
  Button, Flex, Typography, Icon, Modal,
} from '@atoms';
import { ReactComponent as Close } from '@assets/remove-item.svg';

const SpecialWarningModal = ({
  onWarningClose,
  isWarningOpen,
  onSave,
}) => (
  <Modal
    isOpen={isWarningOpen}
    ariaHideApp={false}
    onRequestClose={onWarningClose}
    shouldCloseOnOverlayClick
  >
    <ButtonClose primary onClick={onWarningClose}>
      <Flex justifyCenter itemsCenter>
        <Icon SVG={Close} width="20px" height="20px" />
      </Flex>
    </ButtonClose>
    <Typography size="xl" weight="black">
      Some of your sizes will have
      {' '}
      <Typography as="span" color="strawberry" size="xl" weight="black">$0</Typography>
      {' '}
      price? Would you like to save it?
    </Typography>
    <Flex itemsCenter justifyCenter>
      <Button.Rectangular
        primaryInverted
        gradient
        fullWidth
        padding="sm"
        marginTop="xl2"
        onClick={onWarningClose}
        data-cy="cancel"
      >
        Cancel
      </Button.Rectangular>
      <Button.Rectangular
        primary
        fullWidth
        padding="sm"
        marginTop="xl2"
        marginLeft="lg"
        onClick={onSave}
        data-cy="confirm"
      >
        Save
      </Button.Rectangular>
    </Flex>
  </Modal>
);

const ButtonClose = styled(Button.Circular)`
  ${({ theme: { spacing } }) => css`
    padding: ${spacing.xs};
    position: absolute;
    top: 10px;
    right: 10px;
  `}
`;

SpecialWarningModal.propTypes = {
  onSave: func.isRequired,
  onWarningClose: func.isRequired,
  isWarningOpen: bool.isRequired,
};

export default SpecialWarningModal;
